import React from 'react';
import ContentComponents from '@uplight/marketplace-content';
import getGlobalFromWindow from '../shared/helpers/getGlobalFromWindow';
import Page from './Page';


class ProgramPage extends Page {
  static getDomId() {
    return 'content_program_page';
  }

  render() {
    const { instanceId } = this.props;
    const siteId = getGlobalFromWindow('siteId');

    return (
      <ContentComponents.ProgramPage
        siteId={siteId}
        instanceId={instanceId}
        errorHandler={this.errorHandler}
      />
    );
  }
}

export default ProgramPage;
